var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.87286,
    cy: 13.1808,
    r: 1.74384,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.87286,
    cy: 13.1808,
    r: 1.74384,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.87286,
    cy: 13.1808,
    r: 1.74384,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4714,
    cy: 13.1808,
    r: 1.74384,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4714,
    cy: 13.1808,
    r: 1.74384,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4714,
    cy: 13.1808,
    r: 1.74384,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.302 10.0177L1.30202 12.5686C1.30202 13.1049 1.71523 13.478 2.17428 13.478H2.97755C2.79127 12.3166 3.58357 11.2544 4.90406 11.2544C6.40566 11.2544 6.93397 12.6322 6.7896 13.4808H10.5677C10.3903 12.3781 11.2043 11.2626 12.4252 11.2626C13.9126 11.2626 14.5336 12.5197 14.3599 13.4808H15.4069C15.7056 13.4808 15.9477 13.2387 15.9477 12.94V9.68416C15.9477 9.16225 15.558 8.74576 15.0415 8.6709L13.604 8.45605L12.3735 5.22545C12.2892 5.00334 12.1157 4.85575 11.8696 4.85575L7.72088 4.85561C8.51402 6.44514 8.26001 8.56859 6.70701 9.9105C4.89578 11.4755 2.49043 11.0306 1.302 10.0177ZM12.8195 9.1474H10.5767C10.2095 9.1474 9.95166 8.85921 9.95166 8.51459V6.25287H11.7432L12.8195 9.1474Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.302 10.0177L1.30202 12.5686C1.30202 13.1049 1.71523 13.478 2.17428 13.478H2.97755C2.79127 12.3166 3.58357 11.2544 4.90406 11.2544C6.40566 11.2544 6.93397 12.6322 6.7896 13.4808H10.5677C10.3903 12.3781 11.2043 11.2626 12.4252 11.2626C13.9126 11.2626 14.5336 12.5197 14.3599 13.4808H15.4069C15.7056 13.4808 15.9477 13.2387 15.9477 12.94V9.68416C15.9477 9.16225 15.558 8.74576 15.0415 8.6709L13.604 8.45605L12.3735 5.22545C12.2892 5.00334 12.1157 4.85575 11.8696 4.85575L7.72088 4.85561C8.51402 6.44514 8.26001 8.56859 6.70701 9.9105C4.89578 11.4755 2.49043 11.0306 1.302 10.0177ZM12.8195 9.1474H10.5767C10.2095 9.1474 9.95166 8.85921 9.95166 8.51459V6.25287H11.7432L12.8195 9.1474Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.302 10.0177L1.30202 12.5686C1.30202 13.1049 1.71523 13.478 2.17428 13.478H2.97755C2.79127 12.3166 3.58357 11.2544 4.90406 11.2544C6.40566 11.2544 6.93397 12.6322 6.7896 13.4808H10.5677C10.3903 12.3781 11.2043 11.2626 12.4252 11.2626C13.9126 11.2626 14.5336 12.5197 14.3599 13.4808H15.4069C15.7056 13.4808 15.9477 13.2387 15.9477 12.94V9.68416C15.9477 9.16225 15.558 8.74576 15.0415 8.6709L13.604 8.45605L12.3735 5.22545C12.2892 5.00334 12.1157 4.85575 11.8696 4.85575L7.72088 4.85561C8.51402 6.44514 8.26001 8.56859 6.70701 9.9105C4.89578 11.4755 2.49043 11.0306 1.302 10.0177ZM12.8195 9.1474H10.5767C10.2095 9.1474 9.95166 8.85921 9.95166 8.51459V6.25287H11.7432L12.8195 9.1474Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86627 10.4852C5.9727 10.4852 7.6803 8.77842 7.6803 6.67301C7.6803 4.56761 5.9727 2.86084 3.86627 2.86084C1.75984 2.86084 0.0522461 4.56761 0.0522461 6.67301C0.0522461 8.77842 1.75984 10.4852 3.86627 10.4852ZM4.38028 4.27878C4.38028 4.07034 4.21131 3.90137 4.00288 3.90137C3.79444 3.90137 3.62547 4.07034 3.62547 4.27878V6.60614C3.50367 6.71325 3.42681 6.87024 3.42681 7.04519C3.42681 7.10879 3.43697 7.17002 3.45575 7.22734L2.52873 8.12631C2.3791 8.27141 2.37543 8.51035 2.52054 8.65998C2.66564 8.80962 2.90458 8.81329 3.05421 8.66818L4.13973 7.61551C4.40074 7.55698 4.59577 7.32386 4.59577 7.04519C4.59577 6.86232 4.51179 6.69906 4.38028 6.59188V4.27878Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.b3a245cf414a5b084f5aba38e68bfeb8.svg";
export { ForwardRef as ReactComponent };